import React from 'react'
import { Box, Button } from '@mui/material';

function ReportWorkerPicker({workerFilter, setWorkerFilter}){
    return(
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mb: 2 }}>
                <Button variant={workerFilter ==='drivers' ? 'contained' : 'outlined'} size="small" onClick={() => setWorkerFilter('drivers')}>Kierowcy</Button>
                <Button variant={workerFilter ==='hall_workers' ? 'contained' : 'outlined'} size="small" onClick={() => setWorkerFilter('hall_workers')}>Pracownicy na hali</Button>
                <Button variant={workerFilter ==='all' ? 'contained' : 'outlined'} size="small" onClick={() => setWorkerFilter('all')}>Wszyscy</Button>
            </Box>
        </Box>
    )
}

export default ReportWorkerPicker;